import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { type UrlGroup, type TaskType } from "./useTaskCreation";
import { CostEstimate } from "./CostEstimate";
import type { JSX } from "react";

export function BulkEstimateSummary(props: { taskType: TaskType; groups: UrlGroup[] }) {
  let bulkEstimateSummary: JSX.Element | null;
  const estimate = CostEstimate.bulkEstimate(props.taskType, props.groups);
  if (estimate === null) {
    bulkEstimateSummary = null;
  } else {
    bulkEstimateSummary = (
    <Box maxWidth={640} sx={{ mb: 2 }}>
      <Typography variant="subtitle2">
        Ориентировочная стоимость по всем задачам:{" "}
        {CostEstimate.formatEstimate(estimate.totalUniqueArticles, estimate.totalCost)}
      </Typography>
    </Box>
  );
  }
  return bulkEstimateSummary;
}
